import { useIntl } from "@umijs/max";
import createT from "./createT";
import { getOamIntlConfigFileContent } from "./utils";
/**
 * 翻译主方法
 */
const useT = (bindNameSpace?: string) => {
  const config = getOamIntlConfigFileContent();
  const umiIntl = useIntl();
  const t = createT(umiIntl, config, bindNameSpace);
  return t;
};
export default useT;
